import { render, staticRenderFns } from "./AreaMap.vue?vue&type=template&id=539ae684&scoped=true"
import script from "./AreaMap.vue?vue&type=script&lang=js"
export * from "./AreaMap.vue?vue&type=script&lang=js"
import style0 from "./AreaMap.vue?vue&type=style&index=0&id=539ae684&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539ae684",
  null
  
)

export default component.exports